export default __webpack_public_path__ + "c3535cb177fbb433ecf5cbba2938a2e8.svg";